import { Locale } from '@org-avp/avp-hck-dga-customerui-commons';
import { supportedLocales } from '@/i18n/supportedLocales';

export const getI18nLocale = (locale: Locale): Locale => {
  if (!locale) {
    return Locale.en;
  }
  const i18nLocale = locale.replace('_', '-') as Locale;

  return supportedLocales.includes(i18nLocale) ? i18nLocale : Locale.en;
};
